import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function MainComponent() {

    document.title = "利用者情報変更完了| ファーストコンタクトセンター";
    const navigate = useNavigate();
    const location = useLocation();

    if (!location.state) {
        window.location.replace("/inquiry_status");
    }

    const buttonConfirm = () => {
        navigate("/inquiry_status", { state: { page: true } })
    }

    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>利用者情報変更完了</span>
                    </h2>
                    <div className="mod-txt">
                        <p>
                            利用者情報を更新しました。
                        </p>
                    </div>
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left"
                                onClick={buttonConfirm}>トップページへ</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainComponent;
